<script>
import { watchEffect, ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from "@/plugins/i18n"

export default {
  name: 'RegStatus',
  props: {
    checkStatus: {
      type: String,
      required: true
    },
    rejectRemark: {
      type: String,
      required: true
    },
  },
  setup(props) {
    const store = useStore()
    const { t } = useI18n()
    const kycReviewStatus = computed(() => store.state.auth.registerInfo.kycReviewStatus)
    const status = ref(props.checkStatus)
    const remark = ref(props.rejectRemark)
    watchEffect(() => {
      status.value = props.checkStatus
      remark.value = props.rejectRemark
    })
    return { status, remark, kycReviewStatus, t }
  }
}
</script>

<template>
  <div class="reg-state-wrap">
    <div class="state-label">{{t('dashboard.dialog.label.text_11')}}</div>
    <div class="reason-wrap">
      <div class="reg-succ" v-if="['CF'].includes(status)">
        <svg-icon icon-class="通过" class-name="icon"/>
        <div>{{t('dashboard.bank.content.text_3')}}</div>
      </div>
      <div class="reg-succ" v-if="['CP'].includes(status)">
        <div>{{t('dashboard.bank.content.text_5')}}</div>
      </div>
      <div class="reg-WC" v-if="['WC'].includes(status)">
        <div>{{t('dashboard.bank.content.text_8')}}</div>
      </div>
      <div class="reg-err" v-if="['RJ','RC','ST'].includes(status)">
        <svg-icon icon-class="红色叹号" class-name="icon"/>
        <span style="white-space: nowrap;">{{t('dashboard.bank.content.text_4')}}</span>
        <span style="margin-left: 20px;" v-if="remark">
          {{t('dashboard.step.content.text_17')}}:{{remark}}
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .reg-state-wrap {
    width: 100%;
    display: flex;
    box-sizing: border-box;

    .state-label {
      font-size: 14px;
      color: #002D4F;
      letter-spacing: 0;
      width: 150px;
      box-sizing: border-box;
      height: 40px;
      line-height: 40px;
      margin-bottom: 22px;
    }

    .reason-wrap {
      flex: 1;
      box-sizing: border-box;
      /*height: 40px;*/
      line-height: 40px;
      margin-bottom: 22px;

      .icon {
        width: 20px;
        font-size: 20px;
        margin-right: 14px;
        line-height: 21px;
      }

      .reg-succ {
        font-size: 14px;
        color: #209B75;
        letter-spacing: 0;
        display: flex;
        align-items: center;
      }

      .reg-WC {
        font-size: 14px;
        color: #409EFF;
        letter-spacing: 0;
        display: flex;
      }

      .reg-err {
        font-size: 14px;
        color: #E15C46;
        letter-spacing: 0;
        /*display: flex;*/
      }
    }
  }
</style>
